import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const getRequestBody = (data: any, types: any) => {
  // const getConfig = () => {
  //   let retConfig = {}
  //   data?.data?.accessConfig?.map((item: any, index: number) => {
  //     let subItemConfig = {}
  //     item.subTitleData.map((subItem: any) => {
  //       const actions = Object.keys(subItem)?.filter((key) => key !== 'title' && key !== 'titleAccessible')
  //       let actionsObj = {}
  //       actions.map((action) => {
  //         actionsObj = {
  //           ...actionsObj,
  //           [`${action}`]: {
  //             isAccessible: subItem[action],
  //           },
  //         }
  //       })
  //       subItemConfig = {
  //         ...subItemConfig,
  //         [`${subItem.title}`]: {
  //           isAccessible: subItem.titleAccessible,
  //           ...actionsObj,
  //         },
  //       }
  //     })
  //     retConfig = {
  //       ...retConfig,
  //       [`${item.title}`]: {
  //         isAccessible: item.titleAccessible,
  //         ...subItemConfig,
  //       },
  //     }
  //     return retConfig
  //   })
  //   return retConfig
  // }
  const id = types?.filter((item: any) => item?.value === data?.name)?.[0]?.id
  return {
    id: data?.id,
    type: data?.type ?? '',
    username: data?.username ?? '',
    group: {
      id: id ?? '',
    },
    isActive: data?.status === 'Active' ? true : false,
  }
}

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}

const userUpdate = (data: any, types: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(data?.id ? APIEndPoints.updateUser : APIEndPoints.addUser),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequestBody(data, types),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { userUpdate }
